import React from 'react';
import { NavLink } from 'react-router-dom';

const leadership = [
    {
        image: require('./../../images/our-team5/charman.png'),
        membername: 'S. S. Raam Chendra',
        position: 'Chairman',
        description: 'S. S. Raam Chendra is a highly respected business leader and the guiding force behind JVR & JMR GROUP, two rapidly expanding organizations in the infrastructure and real estate sectors. With 30+ years of proven experience in real estate, land acquisitions, and large-scale land development, he has built a strong legacy of strategic leadership and excellence in execution.'
    },
    {
        image: require('./../../images/our-team5/reddy.png'),
        membername: 'P. Ranga Reddy',
        position: 'Strategic Partner, JMR Group',
        description: 'P. Ranga Reddy is a strategic partner at JMR Group, leading multiple successful infrastructure and development initiatives. He is also the Chairman of Prudhvi Infrastructure Pvt. Ltd., Managing Director of Prudhvi Life Sciences Pvt. Ltd., and Director of Perati Space Private Limited and Perati Realty Private Limited.'
    }
];

const partners = [
    {
        image: require('./../../images/our-team5/murali.png'),
        membername: 'S. Muralidhar Reddy',
        position: 'Partner, JVR Group',
        description: '25 years of real estate experience driving land development and strategic expansion.'
    },
    {
        image: require('./../../images/our-team4/rao.png'),
        membername: 'Allu Venkata Malleswara Rao',
        position: 'Partner, JVR Group',
        description: '30 years in real estate with expertise in sales, customer relations, and project promotion.'
    },
    {
        image: require('./../../images/our-team4/nagalakshi.png'),
        membername: 'K. V. Naga Lakshmi Padmavathi',
        position: 'Partner, JVR Group',
        description: 'GAMA Business Excellence Award 2025 recipient. Leader in women empowerment and real estate strategy.'
    }
];

const advisory = [
    {
        image: require('./../../images/our-team4/nagraghu.png'),
        membername: 'M. Naga Raghu',
        position: 'Advocate & Legal Advisor',
        description: '35 years of legal expertise. Former Chief Legal Advisor to DG of Police.'
    },
    {
        image: require('./../../images/our-team4/ravi.png'),
        membername: 'G. V. R. Ravi',
        position: 'Senior Civil Engineer',
        description: '30 years in architecture and real estate development. B.E., AMIE, F.I.E., ISB Executive Program graduate.'
    },
    {
        image: require('./../../images/our-team4/kulkarni.png'),
        membername: 'Jithender Kalluri',
        position: 'Chartered Accountant',
        description: '10+ years in financial consulting. Virtual CFO specializing in real estate accounting.'
    }
];

const globalCore = [
    {
        image: require('./../../images/our-team4/gopi.png'),
        membername: 'N. Gopi Nath',
        position: 'Senior Global Business Director',
        description: '30 years in real estate operations. Proven track record in revenue growth and team leadership.'
    },
    {
        image: require('./../../images/our-team4/kiran.png'),
        membername: 'Kiran Sandilya',
        position: 'Business Strategist',
        description: '30+ years in global business and real estate. Expert in marketing and business development.'
    }
];

class Team3 extends React.Component {
    render() {
        return (
            <>
                <div className="section-full p-t80 p-b50 bg-white inner-page-padding">
                    <div className="container">
                        {/* TITLE START */}
                        <div className="section-head">
                            <div className="mt-separator-outer separator-left">
                                <div className="mt-separator">
                                    <h2 className="text-uppercase sep-line-one "><span className="font-weight-300 text-primary">Our</span> Team</h2>
                                </div>
                            </div>
                        </div>
                        {/* TITLE END */}
                        {/* IMAGE Team START */}
                        <div className="section-content">
                            {/* Leadership Section */}
                            <div className="mt-separator-outer m-b30">
                                <h3 className="text-uppercase">Chairman & Partner</h3>
                            </div>
                            <div className="row">
                                {leadership.map((item, index) => (
                                    <div key={`lead-${index}`} className="col-md-6 col-sm-6 col-xs-6 col-xs-100pc m-b30">
                                        <div className="our-team-1 hover-animation-1">
                                            <div className="profile-image scale-in-center"><img src={item.image} alt="" /></div>
                                            <div className="figcaption">
                                                <h4>{item.membername}</h4>
                                                <h5>{item.position}</h5>
                                                <p>{item.description}</p>
                                                <div className="icons">
                                                    <NavLink to={"#"} ><i className="fa fa-facebook" /></NavLink>
                                                    <NavLink to={"#"} > <i className="fa fa-twitter" /></NavLink>
                                                    <NavLink to={"#"} > <i className="fa fa-instagram" /></NavLink>
                                                    <NavLink to={"#"} ><i className="fa fa-rss" /></NavLink>
                                                    <NavLink to={"#"} > <i className="fa fa-youtube" /></NavLink>
                                                    <NavLink to={"#"} > <i className="fa fa-linkedin" /></NavLink>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Partners Section */}
                            <div className="mt-separator-outer m-b30">
                                <h3 className="text-uppercase">Partners</h3>
                            </div>
                            <div className="row">
                                {partners.map((item, index) => (
                                    <div key={`partner-${index}`} className="col-md-4 col-sm-6 col-xs-6 col-xs-100pc m-b30">
                                        <div className="our-team-1 hover-animation-1">
                                            <div className="profile-image scale-in-center"><img src={item.image} alt="" /></div>
                                            <div className="figcaption">
                                                <h4>{item.membername}</h4>
                                                <h5>{item.position}</h5>
                                                <p>{item.description}</p>
                                                <div className="icons">
                                                    <NavLink to={"#"} ><i className="fa fa-facebook" /></NavLink>
                                                    <NavLink to={"#"} > <i className="fa fa-twitter" /></NavLink>
                                                    <NavLink to={"#"} > <i className="fa fa-instagram" /></NavLink>
                                                    <NavLink to={"#"} ><i className="fa fa-rss" /></NavLink>
                                                    <NavLink to={"#"} > <i className="fa fa-youtube" /></NavLink>
                                                    <NavLink to={"#"} > <i className="fa fa-linkedin" /></NavLink>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Advisory Section */}
                            <div className="mt-separator-outer m-t40 m-b30">
                                <h3 className="text-uppercase">Advisory Team</h3>
                            </div>
                            <div className="row">
                                {advisory.map((item, index) => (
                                    <div key={`advisor-${index}`} className="col-md-4 col-sm-6 col-xs-6 col-xs-100pc m-b30">
                                        <div className="our-team-1 hover-animation-1">
                                            <div className="profile-image scale-in-center"><img src={item.image} alt="" /></div>
                                            <div className="figcaption">
                                                <h4>{item.membername}</h4>
                                                <h5>{item.position}</h5>
                                                <p>{item.description}</p>
                                                <div className="icons">
                                                    <NavLink to={"#"} ><i className="fa fa-facebook" /></NavLink>
                                                    <NavLink to={"#"} > <i className="fa fa-twitter" /></NavLink>
                                                    <NavLink to={"#"} > <i className="fa fa-instagram" /></NavLink>
                                                    <NavLink to={"#"} ><i className="fa fa-rss" /></NavLink>
                                                    <NavLink to={"#"} > <i className="fa fa-youtube" /></NavLink>
                                                    <NavLink to={"#"} > <i className="fa fa-linkedin" /></NavLink>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Global Core Team Section */}
                            <div className="mt-separator-outer m-t40 m-b30">
                                <h3 className="text-uppercase">Global Core Team</h3>
                            </div>
                            <div className="row">
                                {globalCore.map((item, index) => (
                                    <div key={`global-${index}`} className="col-md-6 col-sm-6 col-xs-6 col-xs-100pc m-b30">
                                        <div className="our-team-1 hover-animation-1">
                                            <div className="profile-image scale-in-center"><img src={item.image} alt="" /></div>
                                            <div className="figcaption">
                                                <h4>{item.membername}</h4>
                                                <h5>{item.position}</h5>
                                                <p>{item.description}</p>
                                                <div className="icons">
                                                    <NavLink to={"#"} ><i className="fa fa-facebook" /></NavLink>
                                                    <NavLink to={"#"} > <i className="fa fa-twitter" /></NavLink>
                                                    <NavLink to={"#"} > <i className="fa fa-instagram" /></NavLink>
                                                    <NavLink to={"#"} ><i className="fa fa-rss" /></NavLink>
                                                    <NavLink to={"#"} > <i className="fa fa-youtube" /></NavLink>
                                                    <NavLink to={"#"} > <i className="fa fa-linkedin" /></NavLink>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default Team3;